export function formatPrice(price, currency) {
  if (price == null) return "";
  return `${(currency || "").toUpperCase()} ${price.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
}

// Canonical Age & Gender audiences a class can be tagged with in the partner
// "Edit Classes" form. Shown as a fixed set so the filter is always available.
export const AGE_OPTIONS = [
  { value: "everyone", label: "Everyone" },
  { value: "adults", label: "Adults" },
  { value: "ladies-only", label: "Ladies Only" },
  { value: "kids", label: "Kids" }
];

// What a client is told after joining a waitlist. A rank is only promised in
// ordered mode, where the engine offers the seat in turn; in race mode everyone
// is told at once and the first to book takes it.
export function joinedWaitlistMessage({ mode, position, count } = {}) {
  if (mode === "race") {
    const others = Math.max(0, (count || 1) - 1);
    return `You're on the waitlist${others ? ` with ${others} other${others === 1 ? "" : "s"}` : ""} — we'll message you the moment a spot opens. First to book gets it.`;
  }
  return `You're #${position || 1} in line — we'll message you when it's your turn, and hold the spot for you.`;
}
